import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../constants/Fonts';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import './LeaderboardPromoSidebar.css';

/** Figma 18115:4095 Features Stack — 6 rows (set repeated twice) */
const DEFAULT_FEATURES = [
  'Unlock 50+ Premium Tier Rewards',
  'Double XP & Points Boosters',
  'Instant Golden Crown Access',
  'Unlock 50+ Premium Tier Rewards',
  'Double XP & Points Boosters',
  'Instant Golden Crown Access',
];

/**
 * Figma 18115:4102 — 24×24 purple circle + 12×12 star.
 */
const PromoStarBadge = () => (
  <span className="lb-promo__star-badge" data-node-id="18115:4102" aria-hidden="true">
    <img
      className="lb-promo__star"
      src={IMAGE_CONSTANTS.V2_LEADERBOARD_PROMO_STAR}
      alt=""
      width={12}
      height={12}
    />
  </span>
);

/**
 * Figma 18115:4088 Promo Sidebar — advertisement column.
 * Nodes: 4091/4092 header · 4120 banner · 4095–4146 features · 4124 CTA
 */
const LeaderboardPromoSidebar = ({
  eyebrow = 'Exclusive Offer',
  title = 'Explore RapBazaar',
  features = DEFAULT_FEATURES,
  ctaLabel = 'Explore Rapbazaar',
  ctaHref = 'https://rapbazaar.rapchiklife.com/',
  bannerSrc,
}) => (
  <aside
    className="lb-promo"
    data-node-id="18115:4088"
    aria-label="Advertisement"
  >
    {/* Figma 18115:4089 — purple→magenta top accent strip */}
    <div className="lb-promo__accent" data-node-id="18115:4089" aria-hidden="true" />

    <div className="lb-promo__header" data-node-id="18115:4090">
      <p
        className="lb-promo__eyebrow"
        style={{ fontFamily: FONTS.INTER_EXTRABOLD }}
        data-node-id="18115:4091"
      >
        {eyebrow}
      </p>
      <h2
        className="lb-promo__title"
        style={{ fontFamily: FONTS.INTER_EXTRABOLD }}
        data-node-id="18115:4092"
      >
        {title}
      </h2>
    </div>

    <div className="lb-promo__banner" data-node-id="18115:4120">
      <img
        className="lb-promo__banner-img"
        src={bannerSrc || IMAGE_CONSTANTS.V2_LEADERBOARD_RAPBAZAAR_BANNER}
        alt="RapBazaar — Power up. Play more. Win big!"
      />
    </div>

    <ul className="lb-promo__features" data-node-id="18115:4095">
      {features.map((item, index) => (
        <li key={`${item}-${index}`} className="lb-promo__feature">
          <PromoStarBadge />
          <span
            className="lb-promo__feature-text"
            style={{ fontFamily: FONTS.INTER_SEMIBOLD }}
          >
            {item}
          </span>
        </li>
      ))}
    </ul>

    <div className="lb-promo__cta-wrap" data-node-id="18115:4122">
      <span className="lb-promo__cta-shadow" data-node-id="18115:4123" aria-hidden="true" />
      <a
        className="lb-promo__cta"
        href={ctaHref}
        target="_blank"
        rel="noopener noreferrer"
        style={{ fontFamily: FONTS.INTER_MEDIUM }}
        data-node-id="18115:4124"
      >
        {ctaLabel}
      </a>
    </div>
  </aside>
);

LeaderboardPromoSidebar.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  ctaLabel: PropTypes.string,
  ctaHref: PropTypes.string,
  bannerSrc: PropTypes.string,
};

export default LeaderboardPromoSidebar;
